
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, User } from "lucide-react";
import { ChangePasswordDialog } from "@/components/nurse/ChangePasswordDialog";

export function SchoolHeader() {
  const { user, logout } = useAuth();

  if (!user) return null;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg">
                {user.schoolName?.charAt(0) || 'S'}
              </span>
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">
                {user.schoolName || 'School Management'}
              </h1>
              <p className="text-sm text-gray-600">Health Management System</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-sm text-gray-600">
              <User className="h-4 w-4" />
              <span>{user.name}</span>
              <span className="text-gray-400">({user.role})</span>
            </div>
            
            {user.role === 'NURSE' && <ChangePasswordDialog />}
            
            <Button 
              variant="outline" 
              size="sm" 
              onClick={logout}
              className="flex items-center space-x-2"
            >
              <LogOut className="h-4 w-4" />
              <span>Logout</span>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}
